import { tokens } from '@airtel/air-design-system';
import { StyleSheet } from 'react-native';
export var getImageBannerStyles = (props, isLargeScreen) => {
  var heightConfig = props.heightConfig;
  return StyleSheet.create({
    imageBannerBackground: Object.assign({}, heightConfig && {
      minHeight: isLargeScreen ? heightConfig === null || heightConfig === void 0 ? void 0 : heightConfig.desktop : heightConfig === null || heightConfig === void 0 ? void 0 : heightConfig.mobile
    }),
    container: {
      marginTop: tokens.spacing.SPACING_36,
      marginLeft: tokens.spacing.SPACING_20
    },
    imageBannerTitle: {
      marginBottom: tokens.spacing.SPACING_12,
      width: '60%',
      justifyContent: 'flex-start'
    },
    imageBannerSubtitle: {
      marginBottom: tokens.spacing.SPACING_12,
      width: '60%'
    },
    imageBannerButtonContainer: {
      display: 'flex',
      flexDirection: 'row',
      alignItems: 'center',
      marginBottom: tokens.spacing.SPACING_22
    },
    imageBannerinfoContainer: {
      marginBottom: tokens.spacing.SPACING_16
    },
    imageBannerinfoItem: {
      flexDirection: 'row',
      alignItems: 'center',
      marginBottom: tokens.spacing.SPACING_10
    },
    imageBannerinfoItemGap: {
      marginBottom: tokens.spacing.SPACING_10
    },
    imageBannerMarginRight: {
      marginRight: tokens.spacing.SPACING_12
    }
  });
};